import React from 'react';
import { renderTotalColorState } from '../actions/render-color-state';
import { ROUND_ONE, TENTH_HOLE } from '../qual-leaderboard-const';
import { getPlayerFormattedTeeTimeByRound, renderQualifiedStatus } from './roundHelper';

export const clubNameView = (title, player) => {
    if (title) {
        return (
            <div
                className="qual-leaderboard__cell qual-leaderboard__cell--title qual-leaderboard__cell--start qual-leaderboard__cell--club-name">
                <div className="qual-leaderboard__cell-name show-desktop">club/attachment</div>
                <div className="qual-leaderboard__cell-name show-mobile">attachment</div>
            </div>
        );
    }
    return (
        <div className="qual-leaderboard__cell qual-leaderboard__cell--club-name">
            <div className="qual-leaderboard__content">{player.clubName}</div>
        </div>
    );
};

export const totalViewField = (title, player) => {
    if (title) {
        return (
            <div
                className="qual-leaderboard__cell qual-leaderboard__cell--title qual-leaderboard__cell--total">
                <div className="qual-leaderboard__cell-name">score</div>
            </div>
        );
    }

    let totalColorState = '';

    if (player.total && player.rounds[0] && player.rounds[1]) {
        totalColorState = renderTotalColorState(player.total, player.rounds[0].parSum, player.rounds[1].parSum);
    }

    return (
        <div className={`qual-leaderboard__cell qual-leaderboard__cell--total ${totalColorState}`}>
            <div className="qual-leaderboard__content">{player.total ? player.total : '-'}</div>
        </div>
    );
};


export const qualifiedReserveFlagView = (title, player) => {
    if (title) {
        return (
            <div
                className="qual-leaderboard__cell qual-leaderboard__cell--title qual-leaderboard__cell--qualify-reserve-flag">
                <div className="qual-leaderboard__cell-name"></div>
            </div>
        );
    }
    return (
        <div className="qual-leaderboard__cell qual-leaderboard__cell--qualify-reserve-flag">
            <div className="qual-leaderboard__content">{player.qualifyReserveFlag}</div>
        </div>
    );
};

export const qualifiedStatusView = (title, player) => {
    if (title) {
        return (
            <div
                className="qual-leaderboard__cell qual-leaderboard__cell--title qual-leaderboard__cell--qualified-status">
                <div className="qual-leaderboard__cell-name"></div>
            </div>
        );
    }
    return (
        <div className="qual-leaderboard__cell qual-leaderboard__cell--qualified-status">
            <div className="qual-leaderboard__content">{renderQualifiedStatus(player)}</div>
        </div>
    );
};

export const teeStartPositionView = (title, player) => {
    if (title) {
        return (
            <div
                className="qual-leaderboard__cell qual-leaderboard__cell--title qual-leaderboard__cell--tee-start-position">
                <div className="qual-leaderboard__cell-name"></div>
            </div>
        );
    }
    return (
        <div className="qual-leaderboard__cell qual-leaderboard__cell--tee-start-position">
            <div className="qual-leaderboard__content">{player.teeStartPosition}</div>
        </div>
    );
};

export const fqHoleView = (title, player) => {
    if (title) {
        return (
            <div
                className="qual-leaderboard__cell qual-leaderboard__cell--title qual-leaderboard__cell--hole">
                <div className="qual-leaderboard__cell-name">holes</div>
            </div>
        );
    }
    return (
        <div className="qual-leaderboard__cell qual-leaderboard__cell--hole">
            <div className="qual-leaderboard__content">{player.hole}</div>
        </div>
    );
};

const showFormattedTeeTime = (player) => {
    if (player && player.isPlaying) {
        const teeTime = getPlayerFormattedTeeTimeByRound(player, ROUND_ONE);

        return teeTime + ` ${player.startingHole === TENTH_HOLE ? '*' : ''}`;
    }

    return '-';
};

export const rqHoleView = (title, player) => {
    if (title) {
        return (
            <div
                className="qual-leaderboard__cell qual-leaderboard__cell--title qual-leaderboard__cell--hole">
                <div className="qual-leaderboard__cell-name">holes</div>
            </div>
        );
    }

    if (player.hole && player.hole !== '-' && player.hole !== '-*') {
        return (
            <div className="qual-leaderboard__cell qual-leaderboard__cell--hole">
                <div className="qual-leaderboard__content">{player.hole}</div>
            </div>
        );
    }

    return (
        <div className="qual-leaderboard__cell qual-leaderboard__cell--hole">
            <div className="qual-leaderboard__content">
                {showFormattedTeeTime(player)}
            </div>
        </div>
    );
};
